import React from "react";
import cogoToast from "cogo-toast";
import { useState, useEffect } from "react";
import {
  AssetCategoryListApi,
  AssetCreateCategoryApi,
  AssetDeleteCategoryApi,
  AssetUpdateCategoryApi,
} from "../../services/Api";
import { SUCCESS_RESULT } from "../../Constants";
import { FaTimes, FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card,
  CardBody,
  CardHeader,
  Table,
  Input,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import BtnSpinner from "../../components/BtnSpinner";
import Swal from "sweetalert2";

const CategoryList = (props) => {
  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const [creatingCategory, setcreatingCategory] = useState(false);
  const [name, setName] = useState("");
  const [show_create_category_dialog, setShow_category_create_dialog] =
    useState(false);
  const [show_update_category_dialog, setShow_category_update_dialog] =
    useState(false);
  const [categoryToUpdate, setCategoryToUpdate] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetch_category_list();
    return () => {};
  }, []);

  const create_new_category = (e) => {
    e.preventDefault();
    setcreatingCategory(true);

    let data = {
      category_name: name,
    };

    AssetCreateCategoryApi(data)
      .then((res) => {
        setcreatingCategory(false);
        setShow_category_create_dialog(false);
        setName("");
        fetch_category_list();
        cogoToast.success("Category created successfully", { hideAfter: 3 });
      })
      .catch((e) => {
        setcreatingCategory(false);
        global.handle_api_error(e);
      });
  };

  const update_new_category = (e) => {
    e.preventDefault();
    setcreatingCategory(true);

    let data = {
      category_id: categoryToUpdate.id,
      category_name: categoryToUpdate.category_name,
    };

    AssetUpdateCategoryApi(data)
      .then((res) => {
        setcreatingCategory(false);
        setShow_category_update_dialog(false);
        setCategoryToUpdate({});
        fetch_category_list();
        cogoToast.success("Category updated successfully", { hideAfter: 3 });
      })
      .catch((e) => {
        setcreatingCategory(false);
        global.handle_api_error(e);
      });
  };

  const fetch_category_list = () => {
    setProcessing(true);

    AssetCategoryListApi()
      .then((res) => {
        setProcessing(false);
        if (res.status == 200) {
          var response = res.data;
          if (response.status == SUCCESS_RESULT) {
            let list = [];
            response.data.forEach((category) => {
              if (category.status == SUCCESS_RESULT) {
                list.push(category);
              }
            });

            setRowData(list);
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message, {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        cogoToast.error("Something went wrong, please Try again.", {
          hideAfter: 5,
        });
      });
  };

  const handleDelete = (category) => {
    Swal.fire({
      title: "Delete Category?",
      text: `Are you sure you want to delete "${category.category_name}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Processing..",
          html: "Please wait...",
          timerProgressBar: true,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            AssetDeleteCategoryApi({
              category_id: category.id,
            })
              .then((res) => {
                Swal.close();
                if (res.status == 200) {
                  var response = res.data;
                  if (response.status == SUCCESS_RESULT) {
                    fetch_category_list();
                    cogoToast.success("Category deleted successfully", {
                      hideAfter: 3,
                    });
                  } else {
                    cogoToast.error(res.data.message, {
                      hideAfter: 5,
                    });
                  }
                } else {
                  cogoToast.error(res.message, {
                    hideAfter: 5,
                  });
                }
              })
              .catch((e) => {
                Swal.close();
                cogoToast.error("Cannot Delete Category", {
                  hideAfter: 5,
                });
                global.handle_api_error(e);
              });
          },
        });
      }
    });
  };

  const handleEdit = (category) => {
    setCategoryToUpdate(category);
    setShow_category_update_dialog(true);
  };

  // Filter data based on search term
  const filteredData = rowData.filter((item) =>
    item.category_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch (e) {
      return dateString;
    }
  };

  return (
    <div style={{ padding: "1rem" }}>
      <Row className="mb-3">
        <Col md={12}>
          <div className="d-flex justify-content-between align-items-center">
            <h2 style={{ margin: 0, fontWeight: "600" }}>Asset Categories</h2>
            <Button
              color="success"
              onClick={() => setShow_category_create_dialog(true)}
              style={{ borderRadius: "6px" }}
            >
              <FaPlus className="me-2" />
              Create New Category
            </Button>
          </div>
        </Col>
      </Row>

      <Card>
        <CardHeader>
          <Row>
            <Col md={6}>
              <h5 className="mb-0" style={{ fontWeight: "600" }}>
                Categories List
              </h5>
            </Col>
            <Col md={6}>
              <Input
                type="text"
                placeholder="Search categories..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ borderRadius: "6px" }}
              />
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          {is_processing ? (
            <div className="text-center py-5">
              <Spinner color="primary" />
              <p className="mt-2 text-muted">Loading categories...</p>
            </div>
          ) : filteredData.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-muted">
                {searchTerm
                  ? "No categories found matching your search."
                  : "No categories found. Create your first category to get started."}
              </p>
            </div>
          ) : (
            <div className="table-responsive">
              <Table hover striped bordered>
                <thead>
                  <tr>
                    <th style={{ width: "60px" }}>#</th>
                    <th>Category Name</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    <th style={{ width: "120px", textAlign: "center" }}>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((category, index) => (
                    <tr key={category.id}>
                      <td>{index + 1}</td>
                      <td>
                        <strong>{category.category_name}</strong>
                      </td>
                      <td>{formatDate(category.created_at)}</td>
                      <td>{formatDate(category.updated_at)}</td>
                      <td>
                        <div className="d-flex justify-content-center gap-2">
                          <Button
                            color="primary"
                            size="sm"
                            onClick={() => handleEdit(category)}
                            style={{ borderRadius: "4px" }}
                          >
                            <FaEdit />
                          </Button>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDelete(category)}
                            style={{ borderRadius: "4px" }}
                          >
                            <FaTrash />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </CardBody>
      </Card>

      {/* Create Category Modal */}
      <Modal
        isOpen={show_create_category_dialog}
        toggle={() => {
          setShow_category_create_dialog(false);
          setName("");
        }}
        centered
      >
        <ModalHeader
          toggle={() => {
            setShow_category_create_dialog(false);
            setName("");
          }}
        >
          <FaPlus className="me-2" style={{ color: "#28a745" }} />
          Create New Category
        </ModalHeader>
        <Form onSubmit={create_new_category}>
          <ModalBody>
            <FormGroup>
              <Label for="category_name">
                Category Name <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="text"
                id="category_name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter category name"
                required
                style={{ borderRadius: "6px" }}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setShow_category_create_dialog(false);
                setName("");
              }}
              disabled={creatingCategory}
            >
              Cancel
            </Button>
            {creatingCategory ? (
              <BtnSpinner
                is_loading={creatingCategory}
                text={"Creating..."}
                color={"white"}
                class={"btn btn-success"}
                size="5"
              />
            ) : (
              <Button color="success" type="submit">
                <FaPlus className="me-1" />
                Create Category
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      {/* Update Category Modal */}
      <Modal
        isOpen={show_update_category_dialog}
        toggle={() => {
          setShow_category_update_dialog(false);
          setCategoryToUpdate({});
        }}
        centered
      >
        <ModalHeader
          toggle={() => {
            setShow_category_update_dialog(false);
            setCategoryToUpdate({});
          }}
        >
          <FaEdit className="me-2" style={{ color: "#007bff" }} />
          Update Category
        </ModalHeader>
        <Form onSubmit={update_new_category}>
          <ModalBody>
            <FormGroup>
              <Label for="update_category_name">
                Category Name <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="text"
                id="update_category_name"
                value={categoryToUpdate?.category_name || ""}
                onChange={(e) => {
                  setCategoryToUpdate((prev) => ({
                    ...prev,
                    category_name: e.target.value,
                  }));
                }}
                placeholder="Enter category name"
                required
                style={{ borderRadius: "6px" }}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setShow_category_update_dialog(false);
                setCategoryToUpdate({});
              }}
              disabled={creatingCategory}
            >
              Cancel
            </Button>
            {creatingCategory ? (
              <BtnSpinner
                is_loading={creatingCategory}
                text={"Updating..."}
                color={"white"}
                class={"btn btn-primary"}
                size="5"
              />
            ) : (
              <Button color="primary" type="submit">
                <FaEdit className="me-1" />
                Update Category
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default CategoryList;
